import React, { useState } from 'react';
import { Linking, ScrollView, View } from 'react-native';
import {
  Appbar, Button, List, Text,
} from 'react-native-paper';
import { useLazyQuery, useQuery } from '@apollo/client';
import { NativeBaseProvider } from 'native-base';
import { useNavigation } from '@react-navigation/native';
import { useToast } from 'react-native-toast-notifications';
import { NAS_FILES_FOR_BROWSING, NAS_BROWSE_DOWNLOAD_URL } from '../../gql/nas/query';

const MIME_ICONS = {
  'image/': 'image',
  'video/': 'video',
  'audio/': 'music',
  'application/pdf': 'file-pdf-box',
};

function mimeIcon(mime) {
  if (!mime) return 'file';
  for (const [prefix, icon] of Object.entries(MIME_ICONS)) {
    if (mime.startsWith(prefix)) return icon;
  }
  return 'file';
}

function formatSize(bytes) {
  if (bytes == null) return '';
  if (bytes < 1024) return `${bytes} o`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} Ko`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} Mo`;
}

function NasBrowse() {
  const toast = useToast();
  const navigation = useNavigation();

  const [currentPath, setCurrentPath] = useState(null);
  const [pathHistory, setPathHistory] = useState([]);

  const { data, loading } = useQuery(NAS_FILES_FOR_BROWSING, {
    variables: { path: currentPath },
    onError: (e) => toast.show(e.message, { type: 'danger' }),
  });
  const items = data?.nasFilesForBrowsing ?? [];

  const [getDownloadUrl] = useLazyQuery(NAS_BROWSE_DOWNLOAD_URL, {
    fetchPolicy: 'network-only',
    onError: (e) => toast.show(e.message, { type: 'danger' }),
  });

  const navigateTo = (path) => {
    setPathHistory((prev) => [...prev, currentPath]);
    setCurrentPath(path);
  };

  const navigateBack = () => {
    const prev = [...pathHistory];
    const last = prev.pop();
    setPathHistory(prev);
    setCurrentPath(last);
  };

  const handleOpen = async (path) => {
    const result = await getDownloadUrl({ variables: { path } });
    const url = result?.data?.nasBrowseDownloadUrl;
    if (url) Linking.openURL(url);
  };

  return (
    <View style={{ flex: 1, backgroundColor: '#fff' }}>
      <Appbar.Header>
        <Appbar.BackAction onPress={() => navigation.goBack()} />
        <Appbar.Content title="Parcourir le NAS" />
      </Appbar.Header>

      <View style={{ flex: 1, padding: 16 }}>
        {pathHistory.length > 0 && (
          <Button icon="arrow-left" onPress={navigateBack} compact style={{ alignSelf: 'flex-start' }}>
            Retour
          </Button>
        )}
        {loading && <Text style={{ padding: 8, opacity: 0.5 }}>Chargement...</Text>}
        <ScrollView>
          {items.map((item) => (
            <List.Item
              key={item.path}
              title={item.name}
              description={item.type === 'file' ? formatSize(item.size) : 'Dossier'}
              left={(props) => (
                <List.Icon {...props} icon={item.type === 'directory' ? 'folder' : mimeIcon(item.mime)} />
              )}
              onPress={() => {
                if (item.type === 'directory') navigateTo(item.path);
                else handleOpen(item.path);
              }}
            />
          ))}
          {!loading && items.length === 0 && (
            <Text style={{ padding: 16, opacity: 0.5, textAlign: 'center' }}>Dossier vide</Text>
          )}
        </ScrollView>
      </View>
    </View>
  );
}

export default function NasBrowseScreen() {
  return (
    <NativeBaseProvider>
      <NasBrowse />
    </NativeBaseProvider>
  );
}
